import dynamic from 'next/dynamic';
import React, { useRef } from 'react';

import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { IWishlistingEventData } from '@/services/analytics/listings/types';
import { ICampsiteCategory } from '@/services/types/search/campgrounds/id';
import { TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { ISearchResultTile } from '@/utility/mapSearchResultToTile';

import { FavoriteToggleButton } from './FavoriteToggleButton';

const FavoriteToggleAnimation = dynamic(
  () => import('./FavoriteToggleAnimation').then(m => m.FavoriteToggleAnimation),
  { ssr: false },
);

type TListingTileFavoriteToggleProps = {
  listingTile: ISearchResultTile | TAutoRentalTile | ICampsiteCategory;
  isLoading?: boolean;
  isFavorite?: boolean;
  favoriteCount?: number;
  hideFavoriteCount?: boolean;
  wishlistingEventData?: IWishlistingEventData;
  showFavoriteToggleAnimation?: boolean;
};

export const ListingTileFavoriteToggle = ({
  listingTile,
  isLoading,
  isFavorite,
  favoriteCount,
  hideFavoriteCount,
  wishlistingEventData,
  showFavoriteToggleAnimation,
}: TListingTileFavoriteToggleProps) => {
  const heartIconContainerRef = useRef<HTMLDivElement>(null);

  if (isLoading) return null;

  return (
    <>
      <WishlistModalWrapper
        item={listingTile}
        itemType="rental"
        isFavorite={isFavorite}
        wishlistingEventData={wishlistingEventData}
        TriggerComponent={({ toggleFavorite }) => (
          <FavoriteToggleButton
            iconRef={heartIconContainerRef}
            isFavorite={isFavorite}
            favoriteCount={favoriteCount}
            hideFavoriteCount={hideFavoriteCount}
            onClick={toggleFavorite}
          />
        )}
      />

      {showFavoriteToggleAnimation && (
        <FavoriteToggleAnimation containerRef={heartIconContainerRef} isFavorite={isFavorite} />
      )}
    </>
  );
};
